import React from "react";
import { Stack, Icon, Typography, Avatar } from "@mui/material";
import rootFetcher from "common/utils/fetcher";
import ReactMarkdown from "react-markdown";
import { MiniLoader } from "common/components/Loader";
import gmtToLocal from "common/utils/gmtToLocal";
import { themeOptions } from "theme";
import { theme } from "theme";
import isValidJSON from "common/utils/isValidJSON";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { dracula } from "react-syntax-highlighter/dist/esm/styles/hljs";
import toast from "react-hot-toast";
export const RenderMarkdown = ({ data }) => {
  return (
    <div
      style={{
        position: "relative",
        maxWidth: "100vw",
        position: "relative",
        width: "100%",
        padding: "20px",
        background: themeOptions.palette.primary.dark,
        borderRadius: "20px",
        border: `1px solid ${themeOptions.palette.text.hint}`,
        transition: "0.1s ease-in-out",
      }}
      alignItems="start"
      // gap={1}

      mt={2}
    >
      {data?.length ? (
        <div style={{ overflowY: "auto", maxHeight: "inherit" }}>
          <ReactMarkdown
            components={{
              h1: ({ children }) => (
                <h1 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                  {children}
                </h1>
              ),
              h2: ({ children }) => (
                <h2 style={{ fontSize: "1.3rem", fontWeight: "bold" }}>
                  {children}
                </h2>
              ),
              h3: ({ children }) => (
                <h3 style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                  {children}
                </h3>
              ),
              h4: ({ children }) => (
                <h4 style={{ fontSize: "1rem", fontWeight: "bold" }}>
                  {children}
                </h4>
              ),
              h5: ({ children }) => (
                <h5 style={{ fontSize: "1rem", fontWeight: "bold" }}>
                  {children}
                </h5>
              ),
              h6: ({ children }) => (
                <h6 style={{ fontSize: "1rem", fontWeight: "bold" }}>
                  {children}
                </h6>
              ),
              p: ({ children }) => <pre>{children}</pre>,

              code({ node, inline, className, children, ...props }) {
                const match = /language-(\w+)/.exec(className || "");
                return !inline && match ? (
                  <SyntaxHighlighter
                    style={dracula}
                    language={match[1]}
                    PreTag="div"
                    {...props}
                  >
                    {String(children).replace(/\n$/, "")}
                  </SyntaxHighlighter>
                ) : (
                  <code className={className} {...props}>
                    {children}
                  </code>
                );
              },
              a: ({ node, ...props }) => (
                <a
                  {...props}
                  style={{ color: "#ff914c", textDecoration: "underline" }}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          >
            {data?.reduce((a, c) => a + c?.message, "")}
            {/* {data?.slice(1, -1)?.length
              ? data
                  ?.slice(1, -1)
                  ?.reduce((a, c) => a + (c?.message || "") + "\n", "")
              : data?.at(-1)?.message} */}
          </ReactMarkdown>
          {/* {data?.map(({ time, type, message }, i) => {
                return (
                  <>
                    <p
                      style={{
                        fontSize: "12px",
                        color: "grey",
                        padding: 0,
                        margin: "5px 0",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <Icon
                        sx={{ fontSize: "16px !important" }}
                        color={type === "error" ? "error" : "success"}
                      >
                        {type === "error" ? "crisis_alert" : "info"}
                      </Icon>
                      {gmtToLocal(
                        new Date(
                          time?.replace(
                            /(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/,
                            "$1-$2-$3T$4:$5:$6Z"
                          )
                        )
                      )}
                    </p>
                    <p style={{ padding: 0, margin: "5px 0" }} key={i}>
                      {message}
                    </p>
                  </>
                );
              })} */}
        </div>
      ) : null}

      {/* {data?.map(({ time, type, message }, i) => {
          return (
            <Stack
              sx={{
                position: "relative",
                width: "100%",
                background: themeOptions.palette.primary.dark,
                borderRadius: "20px",
                border: `1px solid ${themeOptions.palette.text.hint}`,
                transition: "0.1s ease-in-out",
              }}
              p={2}
              gap={1}
              key={i}
              direction="row"
              alignItems={"flex-start"}
            >
              <Icon color={type === "error" ? "error" : "success"}>
                {type === "error" ? "crisis_alert" : "info"}
              </Icon>
              <div style={{ overflow: "hidden" }}>
                <div>
                  {gmtToLocal(
                    new Date(
                      time.replace(
                        /(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/,
                        "$1-$2-$3T$4:$5:$6Z"
                      )
                    )
                  )}
                </div>
                <div>
                  <ReactMarkdown
                    linkTarget="_blank"
                    className="react-markdown-custom"
                  >
                    {isValidJSON(message)
                      ? JSON.stringify(JSON.parse(message), null, 4)
                      : message}
                  </ReactMarkdown>
                </div>
              </div>
            </Stack>
          );
        })} */}
    </div>
  );
};
export default function Log({ event }) {
  const log = event?.key;
  let name = event?.name?.split("_")?.at(-1);
  let cmd_name = event?.name?.split("_")?.at(-2);
  let system_name = event?.name?.split("_")?.at(-3);
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);
  const fetchHandler = async () => {
    if (!data) {
      setLoading(true);
    }
    let res = await rootFetcher(`/api/log?key=${encodeURI(log)}`);
    if (res?.log) {
      setError(false);
      setData(JSON.parse(res.log));
      setLoading(false);
      return res;
    }

    return res;
  };
  const fetchLog = async () => {
    let res = await fetchHandler();
    if (res?.error) {
      toast.error("User not permitted to see this log");
      setError(res?.error);
      setLoading(false);
      return;
    }
    if (res?.log) return;
    while (true) {
      await new Promise((r) => setTimeout(() => r(), 10000));
      const res = await fetchHandler();
      if (res?.error) {
        toast.error("User not permitted to see this log");
        setError(res?.error);
        setLoading(false);
        break;
      }
      if (res?.log) {
        break;
      }
    }
  };

  React.useEffect(() => {
    if (!log || data?.output || data?.children) return;
    fetchLog();
  }, []);
  if (!loading && !data && !error) return null;

  return (
    <Stack p={2} gap={3}>
      <Stack alignItems={"center"} direction="row" gap={1}>
        <Avatar
          sx={{
            width: 60,
            height: 60,
            marginRight: "10px",
          }}
        >
          <Icon
            style={{
              fontSize: "40px",
              color: theme.palette.primary.main,
            }}
          >
            description
          </Icon>
        </Avatar>
        <Stack>
          <Typography variant="h4">{name}</Typography>
          <Typography variant="body2">
            <span>{`${system_name} | ${cmd_name}${
              event?.date ? ` | ${event?.date}` : ""
            }`}</span>{" "}
            {data?.slice(1, -1)?.length ? (
              data?.at(-1) ? (
                <span>- {data?.at(-1)?.message}</span>
              ) : null
            ) : null}
          </Typography>
        </Stack>
      </Stack>
      {loading ? (
        <div
          style={{
            marginTop: "100px",
            flex: 1,
            justifyContent: "center",
            display: "flex",
          }}
        >
          <MiniLoader />
        </div>
      ) : (
        <RenderMarkdown data={data || [{}, { message: error }, {}]} />
        // <div
        //   style={{
        //     position: "relative",
        //     maxWidth: "100vw",
        //     position: "relative",
        //     width: "100%",
        //     padding: "20px",
        //     background: themeOptions.palette.primary.dark,
        //     borderRadius: "20px",
        //     border: `1px solid ${themeOptions.palette.text.hint}`,
        //     transition: "0.1s ease-in-out",
        //   }}
        //   alignItems="start"
        //   // gap={1}

        //   mt={2}
        // >
        //   {data?.length ? (
        //     <>
        //       <ReactMarkdown
        //         components={{
        //           h1: ({ children }) => (
        //             <h1 style={{ fontSize: "1.5px", fontWeight: "bold" }}>
        //               {children}
        //             </h1>
        //           ),
        //           h2: ({ children }) => (
        //             <h2 style={{ fontSize: "1.3rem", fontWeight: "bold" }}>
        //               {children}
        //             </h2>
        //           ),
        //           h3: ({ children }) => (
        //             <h3 style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
        //               {children}
        //             </h3>
        //           ),
        //           h4: ({ children }) => (
        //             <h4 style={{ fontSize: "1rem", fontWeight: "bold" }}>
        //               {children}
        //             </h4>
        //           ),
        //           h5: ({ children }) => (
        //             <h5 style={{ fontSize: "1rem", fontWeight: "bold" }}>
        //               {children}
        //             </h5>
        //           ),
        //           h6: ({ children }) => (
        //             <h6 style={{ fontSize: "1rem", fontWeight: "bold" }}>
        //               {children}
        //             </h6>
        //           ),
        //           p: ({ children }) => (
        //             <p style={{ margin: "0" }}>{children}</p>
        //           ),

        //           code({ node, inline, className, children, ...props }) {
        //             const match = /language-(\w+)/.exec(className || "");
        //             return !inline && match ? (
        //               <SyntaxHighlighter
        //                 style={dracula}
        //                 language={match[1]}
        //                 PreTag="div"
        //                 {...props}
        //               >
        //                 {String(children).replace(/\n$/, "")}
        //               </SyntaxHighlighter>
        //             ) : (
        //               <code className={className} {...props}>
        //                 {children}
        //               </code>
        //             );
        //           },
        //           a: ({ node, ...props }) => (
        //             <a
        //               {...props}
        //               style={{ color: "#ff914c", textDecoration: "underline" }}
        //               target="_blank"
        //               rel="noopener noreferrer"
        //             />
        //           ),
        //         }}
        //       >
        //         {data?.slice(1, -1)?.length
        //           ? data
        //               ?.slice(1, -1)
        //               ?.reduce((a, c) => a + (c?.message || "") + "\n", "")
        //           : data?.at(-1)?.message}
        //       </ReactMarkdown>
        //       {/* {data?.map(({ time, type, message }, i) => {
        //         return (
        //           <>
        //             <p
        //               style={{
        //                 fontSize: "12px",
        //                 color: "grey",
        //                 padding: 0,
        //                 margin: "5px 0",
        //                 display: "flex",
        //                 alignItems: "center",
        //                 gap: "5px",
        //               }}
        //             >
        //               <Icon
        //                 sx={{ fontSize: "16px !important" }}
        //                 color={type === "error" ? "error" : "success"}
        //               >
        //                 {type === "error" ? "crisis_alert" : "info"}
        //               </Icon>
        //               {gmtToLocal(
        //                 new Date(
        //                   time?.replace(
        //                     /(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/,
        //                     "$1-$2-$3T$4:$5:$6Z"
        //                   )
        //                 )
        //               )}
        //             </p>
        //             <p style={{ padding: 0, margin: "5px 0" }} key={i}>
        //               {message}
        //             </p>
        //           </>
        //         );
        //       })} */}
        //     </>
        //   ) : null}

        //   {/* {data?.map(({ time, type, message }, i) => {
        //   return (
        //     <Stack
        //       sx={{
        //         position: "relative",
        //         width: "100%",
        //         background: themeOptions.palette.primary.dark,
        //         borderRadius: "20px",
        //         border: `1px solid ${themeOptions.palette.text.hint}`,
        //         transition: "0.1s ease-in-out",
        //       }}
        //       p={2}
        //       gap={1}
        //       key={i}
        //       direction="row"
        //       alignItems={"flex-start"}
        //     >
        //       <Icon color={type === "error" ? "error" : "success"}>
        //         {type === "error" ? "crisis_alert" : "info"}
        //       </Icon>
        //       <div style={{ overflow: "hidden" }}>
        //         <div>
        //           {gmtToLocal(
        //             new Date(
        //               time.replace(
        //                 /(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})/,
        //                 "$1-$2-$3T$4:$5:$6Z"
        //               )
        //             )
        //           )}
        //         </div>
        //         <div>
        //           <ReactMarkdown
        //             linkTarget="_blank"
        //             className="react-markdown-custom"
        //           >
        //             {isValidJSON(message)
        //               ? JSON.stringify(JSON.parse(message), null, 4)
        //               : message}
        //           </ReactMarkdown>
        //         </div>
        //       </div>
        //     </Stack>
        //   );
        // })} */}
        // </div>
      )}
    </Stack>
  );
}
